import BaseIcon from './BaseIcon';
import React, { ReactElement, SVGProps } from 'react';

export default function SearchIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path d="m19.898 7.853-5.25-5.25a.56.56 0 0 0-.398-.165h-9A1.313 1.313 0 0 0 3.938 3.75v16.5a1.313 1.313 0 0 0 1.312 1.313h13.5a1.313 1.313 0 0 0 1.313-1.313v-12a.56.56 0 0 0-.165-.398m-5.085-3.495 3.33 3.33h-3.33zm3.937 16.081H5.25a.19.19 0 0 1-.188-.188V3.75a.19.19 0 0 1 .188-.187h8.438V8.25a.563.563 0 0 0 .563.563h4.688V20.25a.19.19 0 0 1-.188.188m-4.511-4.743a3.192 3.192 0 1 0-.795.795l1.158 1.158a.563.563 0 0 0 .795-.795zm-4.677-1.82a2.063 2.063 0 1 1 4.125 0 2.063 2.063 0 0 1-4.125 0" fill="currentColor"/>
    </BaseIcon>
  );
}
